import { useCallback } from 'react'

import { Button, Icon } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { FullScreen } from '@modals/layout'
import { Center } from '@shared/components/layout'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import type { Currency } from '@shared/graphql'
import type { LinkProps } from 'next/link'

export interface ApprovalRequiredQueryProps {
  /**
   * Action link href.
   */
  actionLink?: LinkProps['href']
  /**
   * Total step count for progress bar.
   */
  totalSteps?: number
  /**
   * Currency for this approval required instruction.
   */
  currency?: Currency
}

export const ApprovalRequired: React.FC<ApprovalRequiredQueryProps> = ({
  totalSteps,
  actionLink,
}) => {
  const modal = useModal()
  const { t } = useTranslation('modals.transfer')

  const handleModalClose = useCallback(() => {
    modal.close()
  }, [modal])

  return (
    <FullScreen totalSteps={totalSteps}>
      <Center className="font-circular" variant="horizontal">
        <Center>
          <Icon.Circle
            className="bg-success text-icon-success"
            name="CheckCircleSolid"
          />
        </Center>
        <Center>
          <h3 className="my-6 w-152 text-center type-h-page-sm">{t`approvalRequired.title`}</h3>
        </Center>
        <Center>
          <p className="mb-4 w-152 text-center text-neutral-subtle type-intro-sm">
            {t('approvalRequired.description')}
          </p>
        </Center>
        <Center variant="vertical">
          <div className="mt-4 flex space-x-6">
            <Button
              className="w-full border-none bg-accent-purple-gradient"
              onClick={handleModalClose}
              variant="secondary"
            >
              {t`common:done`}
            </Button>
            {actionLink != null && (
              <Button.Link
                anchorComponent={Link}
                className="w-full whitespace-nowrap"
                href={actionLink}
                variant="primary"
              >
                {t`approvalRequired.action`}
              </Button.Link>
            )}
          </div>
        </Center>
      </Center>
    </FullScreen>
  )
}
